import React, { useEffect, useState } from 'react';
import Layout from './Layout';
import { defaultAxiosInstance } from '../api/defaultInstance';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/AdProductDetail.css';

function NewsReleaseCategoryDetail() {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const categoryId = query.get('categoryId');
    const categoryFromState = location.state?.category;

    const [category, setCategory] = useState(categoryFromState);
    const [formData, setFormData] = useState({
        name: categoryFromState?.name || '',
        description: categoryFromState?.description || '',
        labels: Array.isArray(categoryFromState?.labels) ? categoryFromState.labels.join(', ') : '',
        startPrice: categoryFromState?.startPrice || ''
    });
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (!categoryFromState) {
            // state가 없으면 목록으로 이동
            alert('잘못된 접근입니다. 목록으로 이동합니다.');
            navigate('/ads/newsRelease/categories');
        }
    }, [categoryFromState, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleUpdate = async () => {
        const updatedFields = {};
        for (const key in formData) {
            if (String(formData[key]) !== String(category[key])) {
                updatedFields[key] = formData[key];
            }
        }

        if (updatedFields.labels) {
            updatedFields.labels = updatedFields.labels
                .split(',')
                .map(label => label.trim())
                .filter(label => label !== '');
        }

        if (updatedFields.startPrice) {
            updatedFields.startPrice = Number(updatedFields.startPrice);
        }

        if (Object.keys(updatedFields).length === 0) {
            alert('변경된 내용이 없습니다.');
            return;
        }

        updatedFields.categoryId = Number(categoryId);

        try {
            const response = await defaultAxiosInstance.put('/advertisement/admin/newsRelease/category', updatedFields);
            if (response.data.status === 200) {
                alert('카테고리 수정 완료');
                setIsEditing(false);
                setCategory({ ...category, ...updatedFields });
            } else {
                alert('수정 실패');
            }
        } catch (error) {
            console.error('카테고리 수정 오류:', error);
            alert('카테고리 수정 오류');
        }
    };

    const handleDelete = async () => {
        if (window.confirm('카테고리를 삭제하시겠습니까?')) {
            try {
                const response = await defaultAxiosInstance.delete('/advertisement/admin/newsRelease/category', {
                    params: { categoryId }
                });
                if (response.data.status === 200) {
                    alert('카테고리 삭제 완료');
                    navigate('/ads/newsRelease/categories');
                } else {
                    alert('삭제 실패');
                }
            } catch (error) {
                console.error('카테고리 삭제 오류:', error);
                alert('카테고리 삭제 오류');
            }
        }
    };

    return (
        <Layout>
            <div className="ad-product-detail-container">
                <div className="detail-header">
                    <h2>언론배포 카테고리 상세</h2>
                    <div className="detail-button-group">
                        {!isEditing ? (
                            <>
                                <button onClick={() => setIsEditing(true)}>수정 하기</button>
                                <button onClick={handleDelete}>삭제 하기</button>
                            </>
                        ) : (
                            <button onClick={handleUpdate}>저장 하기</button>
                        )}
                    </div>
                </div>
                <div className="detail-form">
                    <div className="form-group">
                        <label>카테고리명</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </div>
                    <div className="form-group full-width">
                        <label>카테고리 설명</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </div>
                    <div className="form-group">
                        <label>라벨 (쉼표로 구분)</label>
                        <input
                            type="text"
                            name="labels"
                            value={formData.labels}
                            onChange={handleChange}
                            disabled={!isEditing}
                            placeholder="예: 뉴스,보도자료,언론"
                        />
                    </div>
                    <div className="form-group">
                        <label>시작 금액</label>
                        <input
                            type="number"
                            name="startPrice"
                            value={formData.startPrice}
                            onChange={handleChange}
                            disabled={!isEditing}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default NewsReleaseCategoryDetail; 